import React, { useEffect, useState } from 'react';
import { TartaWordmark } from './TartaWordmark';
const navLeft = [{
  label: 'The Cheesecake',
  href: '#product'
}, {
  label: 'Occasions',
  href: '#perfect-for'
}];
const navRight = [{
  label: 'Enquiries',
  href: '#faq'
}, {
  label: 'Reserve',
  href: '#waitlist'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-700 ${scrolled ? 'bg-chocolate/85 backdrop-blur-xl border-b border-cream/5' : 'bg-transparent'}`} data-id="element-70">
      <div className="relative max-w-[1500px] mx-auto px-6 lg:px-16 h-24 lg:h-28 flex items-center justify-center" data-id="element-71">
        {/* Desktop left nav */}
        <nav className="hidden md:flex items-center gap-10 absolute left-6 lg:left-16 top-1/2 -translate-y-1/2" data-id="element-72">
          {navLeft.map(link => <a key={link.href} href={link.href} className="text-[10px] tracking-[0.3em] uppercase text-cream/60 hover:text-cream transition-colors duration-500 relative group" data-id="element-73">
              {link.label}
              <span className="absolute -bottom-1.5 left-0 w-0 h-px bg-caramel transition-all duration-500 group-hover:w-full" data-id="element-74" />
            </a>)}
        </nav>

        {/* Mobile hamburger */}
        <button onClick={() => setOpen(!open)} className="md:hidden absolute left-6 top-1/2 -translate-y-1/2 text-cream" aria-label="Toggle menu" data-id="element-75">
          <div className="w-6 flex flex-col gap-1.5" data-id="element-76">
            <span className={`h-px bg-cream transition-all duration-500 ${open ? 'rotate-45 translate-y-1.5' : ''}`} data-id="element-77" />
            <span className={`h-px bg-cream transition-all duration-500 ${open ? 'opacity-0' : ''}`} data-id="element-78" />
            <span className={`h-px bg-cream transition-all duration-500 ${open ? '-rotate-45 -translate-y-1.5' : ''}`} data-id="element-79" />
          </div>
        </button>

        {/* Centered wordmark */}
        <a href="#top" className="flex flex-col items-center text-cream" data-id="element-80">
          <TartaWordmark height={22} data-id="element-81" />
          <span className="mt-2.5 text-[9px] tracking-[0.4em] uppercase text-cream/50" data-id="element-82">
            A slice of heaven
          </span>
        </a>

        {/* Desktop right nav */}
        <nav className="hidden md:flex items-center gap-10 absolute right-6 lg:right-16 top-1/2 -translate-y-1/2" data-id="element-83">
          {navRight.map((link, i) => {
          const isReserve = i === navRight.length - 1;
          return <a key={link.href} href={link.href} className={`text-[10px] tracking-[0.3em] uppercase transition-colors duration-500 relative group ${isReserve ? 'text-caramel hover:text-cream' : 'text-cream/60 hover:text-cream'}`} data-id="element-84">
                {link.label}
                <span className={`absolute -bottom-1.5 left-0 h-px transition-all duration-500 ${isReserve ? 'w-full bg-caramel/50 group-hover:bg-caramel' : 'w-0 bg-caramel group-hover:w-full'}`} data-id="element-85" />
              </a>;
        })}
        </nav>

        {/* Mobile right "Reserve" */}
        <a href="#waitlist" className="md:hidden absolute right-6 top-1/2 -translate-y-1/2 text-[10px] tracking-[0.3em] uppercase text-caramel" data-id="element-86">
          Reserve
        </a>
      </div>

      {open && <div className="md:hidden bg-chocolate/95 backdrop-blur-xl border-t border-cream/5 px-8 py-8 space-y-5" data-id="element-87">
          {[...navLeft, ...navRight].map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="block text-[10px] tracking-[0.3em] uppercase text-cream/80" data-id="element-88">
              {link.label}
            </a>)}
        </div>}
    </header>;
}